import track from './track'

export default store => next => action => {
  track(action)
  return next(action)
}



// WEBPACK FOOTER //
// ./src/store/analytics.js